import { storyPointsDefaultOptions } from "../company-settings";
import ServerSettings, {ServerSettingsFieldType} from "../../../gd/settings/server-settings/server-settings";

// const debug = "CompanySettingsFields"
const debug = false

const fieldsConfig = {

    'storyPoints': {
        type            : ServerSettingsFieldType.VALUE,
        defaultValue    : storyPointsDefaultOptions,
    },
    'projectHealthCanHaveNoValue': {
        type            : ServerSettingsFieldType.BOOLEAN,
        defaultValue    : true,
    },



}

export default class CompanySettingsFields extends ServerSettings {

    public storyPoints                      : any
    public projectHealthCanHaveNoValue      : boolean


    constructor(config:any) {

        debug && console.log(debug,'.constructor', config);

        super(config, fieldsConfig);

        this.storyPoints                 = this.initValue('storyPoints')  // default storage provider for uploads
        this.projectHealthCanHaveNoValue = this.initValue('projectHealthCanHaveNoValue')  // default storage provider for uploads

        debug && console.log(debug,'.constructor - done', this);
    }


    toJSON() {
        const result = {};

        this.valueToJson(result, 'storyPoints')
        this.valueToJson(result, 'projectHealthCanHaveNoValue')

        return result;
    }

}